


































































































import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator';
import { Getter, Action, State } from 'vuex-class'
import Payment from '@/modules/payment/model/Payment'
import { Route } from 'vue-router';
import KeyValuePair from '@/modules/core/support/KeyValuePair';

@Component
export default class PaymentDetail extends Vue {

    @State(state => state.payment.currentPayment)
    public payment: Payment

    @Action('payment/loadPayment')
    public loadPayment: (id: number) => void

    public loading = true

    @Watch('$route') public async onRoute (to: Route, from: Route) {
        this.loading = true
        // tslint:disable-next-line:radix
        await this.loadPayment(parseInt(to.params.id))
        this.loading = false
    }

    public async created () {
        // tslint:disable-next-line:radix
        await this.loadPayment(parseInt(this.$route.params.id))
        this.loading = false
    }

    public cartTableHeaders = [
        { text: 'Código de producto', value: 'id' },
        { text: 'Descripción', value: 'name'},
        { text: 'Unidades compradas', value: 'units'},
        { text: 'Acciones', value: 'id', sortable: false},
    ]

    public detailTableHeaders = [
        { text: 'Clave', value: 'key'},
        { text: 'Valor', value: 'value'},
    ]

    public get paymentState (): string {
        const map: KeyValuePair = {pending: 'Pendiente', done: 'Completado'}

        return map[this.payment.state] || 'Desconocido'
    }

    get details (): any[] {
        const details = this.payment.details
        const map: any[] = []

        for (const key in details) {
            if (!details.hasOwnProperty(key)) {
                continue
            }

            const value = details[key]

            if (_.isObject(value) || _.isArray(value)) {
                continue
            }

            map.push({key, value})
        }

        return map
    }

}
